import { z } from 'zod';
import { IDENTIFIER_TYPE } from 'src/features/membership/types';
import { ALLOW_LIST_TYPE } from 'src/features/allowList/utils/types';
import { validationMessagesMap } from 'src/utils/messages';

export type AllowListFormSchemaValues = z.infer<typeof allowListFormSchema>;
export const allowListFormSchema = z.object({
    name: z.string(),
    description: z.string().nullish(),
    type: z.enum(ALLOW_LIST_TYPE),
    allowed_gateways: z.array(z.string()),
    zones: z.array(z.string()),
});

export type AllowListItemFormSchemaValues = z.infer<typeof allowListItemFormSchema>;
export const allowListItemFormSchema = z
    .object({
        name: z.string(),
        identifier_type: z.enum(IDENTIFIER_TYPE),
        identifier_value: z.string().nullish(),
    })
    .superRefine((data, ctx) => {
        if (data.identifier_type && !data.identifier_value) {
            ctx.addIssue({
                path: ['identifier_value'],
                message: validationMessagesMap.validationErrorRequired,
                code: 'custom',
            });
        }
    });
